import React, { useRef } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"

import Button from './Button'

import Box from '@material-ui/core/Box'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import { Avatar } from '@material-ui/core'

const styles = theme => ({
  navigationSlider: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    right: 0
  },
  chevronCard: {
    cursor: 'pointer',
    background: 'transparent',
    border: '1px solid',
    borderColor: theme.palette.primary.main
  },
  iconChevron: {
    fontSize: 24,
    color: theme.palette.primary.main,
    fontWeight: 'bold'
  }
})

const SliderBox = ({ classes, children, slidesToShow }) => {
  const sliderRef = useRef(null);

  const settings = {
    arrows: false,
    infinite: true,
    speed: 800,
    slidesToShow: slidesToShow,
    slidesToScroll: 3,
    pauseOnHover: false,
    autoplay: false,
    autoplaySpeed: 5000
  };
  
  return (
    <>
        <Slider {...settings} ref={sliderRef}>
            { children }
        </Slider>
        <Box className={classes.navigationSlider}>
          <Button icon={ChevronLeftIcon} onClick={() => sliderRef.current.slickPrev()} />
          <Button icon={ChevronRightIcon} onClick={() => sliderRef.current.slickNext()} />
        </Box>
    </>
  )
}

export default withStyles(styles)(SliderBox)